import BroadCast from 'views/BroadCast/BroadCast';
import { connect } from 'react-redux';
import { getUser } from 'store/selector/auth.selector';
import { roomStatusRequest } from 'store/actions/conversation.actions';

const mapDispatchToProps = { roomStatus: roomStatusRequest};

const mapStateToProps = (state: any) => {
  const user = getUser(state);
  return { user };
};

export default connect(mapStateToProps, mapDispatchToProps)(BroadCast);
